const React = require("react");

const activateWDDR = false;
const SESSION_TYPE_KEY = "sessionType";
const SESSION_TYPE_NORMAL = "normal";
const SESSION_TYPE_RETAIL = "retail";
const RETAIL_UTM_VALUE_PATTERNS = [/\bretail\b/i, /\brmn[\s_-]?events?\b/i];

require("./src/assets/global_functions.js");

function isRetailUtmValue(value = "") {
	return RETAIL_UTM_VALUE_PATTERNS.some((pattern) => pattern.test(value));
}

function updateSessionTypeFromLocation(location) {
	if (typeof window === "undefined") return;

	try {
		const currentSessionType = window.sessionStorage.getItem(SESSION_TYPE_KEY);

		if (![SESSION_TYPE_NORMAL, SESSION_TYPE_RETAIL].includes(currentSessionType)) {
			window.sessionStorage.setItem(SESSION_TYPE_KEY, SESSION_TYPE_NORMAL);
		}

		const search = location?.search || "";
		if (!search) return;

		const hasRetailUtm = [...new URLSearchParams(search).entries()].some(([key, value]) => {
			return key?.toLowerCase().startsWith("utm_") && isRetailUtmValue(value || "");
		});

		if (hasRetailUtm) {
			window.sessionStorage.setItem(SESSION_TYPE_KEY, SESSION_TYPE_RETAIL);
		}
	} catch (error) {
		// Ignore storage issues (private browsing / blocked storage).
	}
}

exports.onClientEntry = () => {
	updateSessionTypeFromLocation(window.location);

	if (process.env.GATSBY_ACTIVE_ENV === "development" && activateWDDR) {
		const whyDidYouRender = require("@welldone-software/why-did-you-render");
		whyDidYouRender(React, {
			trackAllPureComponents: true,
			trackHooks: true,
			include: [/Page/],
		});
	}

	// Force service worker update on page load
	/* if ("serviceWorker" in navigator) {
		navigator.serviceWorker.getRegistrations().then((registrations) => {
			registrations.forEach((registration) => {
				// Force immediate update check
				registration.update();

				// If there's a waiting service worker, skip waiting and reload
				if (registration.waiting) {
					registration.waiting.postMessage({ type: "SKIP_WAITING" });
					window.location.reload();
				}
			});
		});

		// Listen for service worker updates
		navigator.serviceWorker.addEventListener("controllerchange", () => {
			// New service worker has taken control, reload to get fresh content
			if (!window.__swUpdateHandled) {
				window.__swUpdateHandled = true;
				window.location.reload();
			}
		});
	} */

	// Handle CSS loading errors in development
	if (process.env.NODE_ENV === "development") {
		// Listen for resource loading errors
		window.addEventListener(
			"error",
			(event) => {
				if (event.target && event.target.tagName === "LINK" && event.target.rel === "stylesheet") {
					console.warn("CSS file failed to load, retrying:", event.target.href);

					// Remove the failed link element
					const failedLink = event.target;
					failedLink.remove();

					// Create a new link element with the same href
					const newLink = document.createElement("link");
					newLink.rel = "stylesheet";
					newLink.href = failedLink.href;
					newLink.onerror = () => {
						console.error("CSS retry failed, page may need manual refresh");
					};
					document.head.appendChild(newLink);
				}
			},
			true
		);
	}
};

exports.onRouteUpdate = ({ location }) => {
	updateSessionTypeFromLocation(location);

	if (location.hash) {
		const treatedHash = location.hash.replace(/\./g, "_");
		const targetElement = document.querySelector(treatedHash);
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: "smooth" });
		}
	} else {
		window.scrollTo(0, 0);
	}
};
